import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="financiamentos"]');

class Financiamentos {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const swiperEl = component.querySelector('.swiper');
            if (swiperEl) this.initSwiper(swiperEl);
        });
    }

    initSwiper(swiperEl) {
        new Swiper(swiperEl, {
            modules: [FreeMode],
            slidesPerView: 'auto',
            spaceBetween: 18,
            freeMode: true,
        });
    }
}

(() => {
    if (MODULE.length) {
        new Financiamentos();
    }
})();

export default Financiamentos;
